export const rangeSeparator = '-'
export const premiumHomePageUrl = '/admin/analyze/search_usage'
export const standardHomePageUrl = '/admin/settings/scope/catalogs'
